<template lang="pug">
    div.scrollable-layout(:style="theStyle")
        div
            custom-scrollbar-control.scrollable-layout__scrollbar(ref="scrollbar")
                div.scrollable-layout__content
                    slot
                resize-sensor(v-if="maxHeight" @resize="contentResize")
</template>

<script>
export default {
    name: 'scrollable-layout',

    props: {
        maxHeight: {
            type: [Number, Boolean],
        },
    },

    data() {
        return {
            contentHeight: null,
        }
    },

    computed: {
        theStyle() {
            return {
                'height': this.contentHeight && `${this.contentHeight}px`,
                'max-height': typeof(this.maxHeight) == 'number' && `${this.maxHeight}px`,
            }
        },
    },

    methods: {
        scrollTo(top, smooth = true) {
            this.$refs.scrollbar.$refs.scroll.scrollElement.scrollTo({
                top: top,
                behavior: smooth ? 'smooth' : 'instant'
            })
        },
        scrollToBottom() {
            this.scrollTo(this.$refs.scrollbar.$refs.scroll.scrollElement.scrollHeight)
        },

        contentResize(e) {
            this.contentHeight = e.height
        },
    }
}
</script>
